<button class="boton-descarga">
  <img class="boton-descarga__icon" src="../../../../assets/descargar.svg" />
  Descargar
</button>
